import type { JSX, MemoExoticComponent } from 'react'
import type { Scope, ScopeList } from '../core'
import type { MapSkinView } from './Map'
import type { OverSkinView } from './Over'
import type { Recursive } from './Recursive'

import { memo } from 'react'
import { get, key, Special, useRaw } from '../core'
import { hasMap, Map } from './Map'
import { hasOver, Over } from './Over'

interface Props {
  skin: MapSkinView | OverSkinView
  parent: Scope
  Recursive: Recursive
  [key: string]: unknown // any additional props, will be propogated to all elements in list
}

// exports memoized component
export const Many: MemoExoticComponent<typeof Many_> = memo(Many_)

// Many_.whyDidYouRender = true
Many_.displayName = 'Many'
function Many_({
  skin,
  parent,
  Recursive,
  ...props
}: Props): JSX.Element | null {
  let listName: 'map' | 'over' | undefined
  let MapOrOver: typeof Map | typeof Over | undefined

  if (hasMap(skin)) {
    listName = 'map'
    MapOrOver = Map
  } else if (hasOver(skin)) {
    listName = 'over'
    MapOrOver = Over
  }

  if (listName && MapOrOver) {
    const rawList = get(Special.List + listName, parent)

    // this is ok, because skin is static and never changes on the fly
    // oxlint-disable-next-line eslint-plugin-react-hooks/rules-of-hooks
    const list = useRaw(rawList) as ScopeList
    if (list) {
      return (
        <MapOrOver
          {...props}
          scopeList={list}
          key={key(skin)}
          skin={skin as MapSkinView & OverSkinView}
          parent={parent}
          Recursive={Recursive}
        />
      )
    }
  }

  return null
}

export { hasMap, hasOver }
